import React, { useState,useRef,useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Alert,
  Paper, Button, Dialog, DialogTitle, DialogContent, Typography,Stack,DialogActions
} from '@mui/material';
import { CSVLink } from "react-csv";
import { IoMdDownload } from "react-icons/io";
import axios from 'axios';
import { BASE_API_URL } from '../utils/constants';
import { toyyyymmdd } from '../utils/formatDate';
import InterestedCandidates from './InterestedCandidates';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteConfirmationModal from "../utils/DeleteConfirmationModal";
import "./CourseMaster.css";
import DatePicker from 'react-datepicker';
import Box from "@mui/material/Box";
import LeftArrow from '@mui/icons-material/KeyboardArrowLeft';
import RightArrow from '@mui/icons-material/KeyboardArrowRight';


export default function TrainingTable() {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openIntCanModal, setOpenIntCanModal] = useState(false);
  const [regLink,setRegLink]= useState("");
  const [trainings, setTrainings]= useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading]= useState(false);
  const [deleting, setDeleting] = useState(false);
  const [uploading, setUploading]= useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [file,setFile]= useState(null);
  const ref = useRef();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1–12
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const columns= [
    {id:"1", label:"Sno."},
    {id:"2", label:"Training Name"},
    {id:"8", label:"Primary Skill"},
    {id:"9", label:"Span"},
    {id:"10", label:"SSI Bundle"},
    {id:"3", label:"Mode"},
    // {id:"4", label:"Duration (hrs)"},
    {id:"5", label:"Start Date"},
    {id:"6", label:"End Date"},
    // {id:"7", label:"Time"},
    {id:"11", label:"Actions"},
  ]; 

   const headers=[
    {label:"Training Name", key:"name"},
    {label:"Primary Skill", key:"primary_skill"},
    {label:"Span", key:"span"},
    {label:"SSI Bundle", key:"ssi_bundle"},
    {label:"Mode", key:"mode"},
    {label:"Duration (hrs.)", key:"duration"},
    {label:"Start Date", key:"start_date"},
    {label:"End Date", key:"end_date"},
    {label:"Time", key:"time"},
    {label:"Workday Registration Link", key:"registration_link"}
   ];

  const fetchTrainings= async()=>{
    try{
      setLoading(true);
      const response= await axios.get(`${BASE_API_URL}/bundleSkills/trainings`,{
        headers:{
          Authorization:localStorage.getItem("token"),
          "Content-Type": "application/json",
        }
      });
      setTrainings(response.data);
    }catch(err){
      console.error("Failled to fetch trainings ",err);
      alert("Failled to fetch trainings");
    }finally{
      setLoading(false);
    }
  }

  useEffect(()=>{
    fetchTrainings();
  },[]);

  const saveFile = (e) => {
    setFile(e.target.files[0]);
  };

   const handleUpload = async() => {
      const formData = new FormData();
      formData.append("file", file);
  
      try{
        const response= await axios.post(`${BASE_API_URL}/bundleSkills/sessionsfile`, 
          formData,{
          headers: {
            Authorization: localStorage.getItem("token"),
          }
        }
        );
        setIsFileUploaded(true);
        setFile(null);
        alert("Uploaded Courses successfully");
        // fetchSessions();
        if (ref.current) {
          ref.current.value = null; // Reset the file input
        }
      }catch(err){
        console.log('err', err)
      }
  };

  const handleDelete= async(id)=>{
    setDeleting(true);
    try{
      const response = await axios.delete(`${BASE_API_URL}/bundleSkills/training/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        }
      });
      setOpen(false);
      setDeleting(false);
      alert("Successfully Deleted training");
    }catch(err){
      setOpen(false);
      setDeleting(false);
      alert("Failed Deleted training.");
      console.error("Unable to delete the training",err);
    }
  }

  const handleOpenIntCan = (row) => {
    setSelectedRow(row);
    setOpenIntCanModal(true);
  };

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handledateChange = (value) => {
  setSelectedDate(value);
  const date = new Date(value);
  const month = date.getMonth();
  const year = date.getFullYear();
  setSelectedMonth(month);
  setSelectedYear(year);
 };

  const handleTrainingTemplateDownload =async()=>{
        try {      
      let fileUrl = process.env.PUBLIC_URL + "/template/Template_TrainingSessions-Bundleskills.xlsx";
      let fileName = `training-Sessions_Template_BundleSkills.xlsx`;
      const response = await fetch(fileUrl);
      const blob = await response.blob();  
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`;
      link.target = "_blank";        
      document.body.appendChild(link);
      link.click();  
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  }

  const filteredTrainings = trainings?.filter((training) => {
    const start = new Date(training.start_date);
    const month = start.getMonth();
    const year = start.getFullYear();
    return month === selectedMonth && year === selectedYear;
  });

  return (
    <>
      <Stack sx={{marginTop:"0px"}}>

        <Stack>
          <h3 className="upload_section_header">Trainings Data</h3>
          <p className="upload_section_para">
            This section lists the training Sessions that are offered by L&TT. You as Admin can Add new
            trainings or delete the existing ones.
          </p>
        </Stack>
      <Box className="select_month_year_section" style={{width: '100%',textAlign:"center"}}>
      <div className="session__month_selector">
        <DatePicker
        selected={selectedDate}
        placeholderText="MM/YYYY"
        className="month-year-picker"
        onChange={(date) => handledateChange(date)}
        dateFormat="MMMM, yyyy"
        showMonthYearPicker
        renderCustomHeader={({
          date,
          changeYear,
        }) => (
          <div className="custom-header">
            <LeftArrow className = "arrow" onClick={() => changeYear(date.getFullYear() - 1)} />
            <span>{date.toLocaleString('default', { month: 'long' })} {date.getFullYear()}</span>
            <RightArrow className = "arrow" onClick={() => changeYear(date.getFullYear() + 1)} />
          </div>
        )}
      />
      </div>
      </Box>
        <div className="course-actions-header" style={{marginBottom:"10px"}}>
          <div className="download_section">
            <div className="training-courses-download">
              <CSVLink data={filteredTrainings} headers={headers} filename={"trainingsdata_bundleSkills.csv"} target="_blank" className="training-courses-download-btn">
                Trainings Data <IoMdDownload style={{ "vertical-align": "text-bottom", marginLeft: "2px" }} />
              </CSVLink>
            </div>
            <button className="course_master__sample_file_download" onClick={handleTrainingTemplateDownload} style={{ padding: '6px 15px' }}>
              <span>Download Template <IoMdDownload style={{ "vertical-align": "text-bottom", marginLeft: "2px" }} /></span>
            </button>
          </div>
   
          <Stack sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>          
            <Stack spacing={2} direction={"row"} alignItems={"center"}>
              <input type="file" accept=".xlsx" ref={ref} id="file" onChange={saveFile} hidden />
              <label className="th-mainData" for="file">
                Select File
              </label>
              <span className="th-file_caption">
                {file ? file.name : "No File Selected"}
              </span>
              <Button
                className={
                  uploading === false
                    ? "th-upload_button_modal_active"
                    : "th-upload_button_modal_inactive"
                }
                onClick={handleUpload}
                sx={{ marginTop: "10px", marginLeft: "20px" }}
              >
                {uploading === false ? "Upload" : "Cancel"}
              </Button>
              {/* {isFileUploaded && <Alert className="file-status" severity={severity} onClose={() => setIsFileUploaded(false)}>{uploadStatusMsg}</Alert>} */}
            </Stack>
          </Stack>
        </div>        
      </Stack>

      <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="courseMasterTable">
        <Table>
          <TableHead>
            <TableRow>
               {columns.map((column) => (
                 <TableCell
                   key={column.id}
                   align={column.align}
                   style={{
                     top: 0,
                     minWidth: column.minWidth,
                     color: "#fff",
                     backgroundColor: "#550A69",
                   }}
                 >
                   {column.label}
                 </TableCell>
               ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading? "Loading.. ": filteredTrainings?.map((training, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{training.name||"NA"}</TableCell>
                <TableCell>{training.primary_skill ||"NA"}</TableCell>
                <TableCell>{training.span||"NA"}</TableCell>
                <TableCell>{training.ssi_bundle||"NA"}</TableCell>
                <TableCell>{training.mode?.toUpperCase()|| "NA"}</TableCell>
                {/* <TableCell>{training.duration|| "NA"}</TableCell> */}
                <TableCell>{toyyyymmdd(training.start_date)||"NA"}</TableCell>
                <TableCell>{toyyyymmdd(training.end_date)||"NA"}</TableCell>
                {/* <TableCell>{training.time||"NA"}</TableCell> */}
                <TableCell>
                  <div style={{display:"flex", flexDirection:'row'}}>
                  <Button
                    sx={{textTransform:"none"}}
                    size="small"
                    onClick={() => handleOpenModal(training)}
                  >
                     View Details
                  </Button>
                  <Button
                    sx={{textTransform:"none"}}
                    size="small"
                    onClick={() => handleOpenIntCan(training)}
                  >
                    Interested Candidates
                    </Button>

                    <DeleteOutlineIcon align="center"
                      onClick={() => {
                        setOpen(training.id);
                      }}
                      sx={{ cursor: "pointer" }} />

                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

        <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>Training Details</DialogTitle>
        <DialogContent dividers>
          {selectedRow && (
            <>
              <Typography><strong>Training Duration:</strong> {selectedRow.duration && `${selectedRow.duration} hours`}</Typography>
              <Typography><strong>Time:</strong> {selectedRow.time}</Typography>
              <Typography><strong>Workday Registration Link:</strong> <a href={selectedRow.registration_link} target="_blank" rel="noopener noreferrer">{selectedRow.registration_link}</a></Typography>
            </>
          )}
        </DialogContent>
      </Dialog>
      <InterestedCandidates
        trainingName={selectedRow?.name}
        list={selectedRow?.interested_candidates}
        open={openIntCanModal}
        setOpen={setOpenIntCanModal} />
      <DeleteConfirmationModal
        open={open}
        onCancel={() => setOpen(null)}
        onConfirm={()=>handleDelete(open)}
        deleting={deleting}
        title="Delete Training"
        message="Are you sure you want to delete this training? This action cannot be undone."
      />
    </>
  );
}
